import React from 'react';
import { X, Eye } from 'lucide-react';

export const ResearchWatchlist = ({ items, onSelect, onRemove }) => (
  <div data-testid="research-watchlist">
    <h4 className="text-sm font-semibold text-white flex items-center gap-2 mb-2"><Eye className="w-4 h-4" /> Watchlist (this browser only)</h4>
    {items.length === 0 ? (
      <p className="text-xs text-gray-500" data-testid="research-watchlist-empty">No entries yet. Watchlists observe data only.</p>
    ) : (
      <div className="flex flex-wrap gap-2">
        {items.map((it) => (
          <span key={`${it.type}:${it.value}`} data-testid={`watchlist-item-${it.type}-${it.value}`}
            className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-xs text-gray-200">
            <button type="button" onClick={() => it.type === 'ticker' && onSelect(it.value)} className={it.type === 'ticker' ? 'hover:text-[#00E676]' : 'cursor-default'}>
              {it.type === 'manager' ? 'Manager: ' : ''}{it.value}
            </button>
            <button type="button" onClick={() => onRemove(it)} aria-label="Remove" data-testid={`watchlist-remove-${it.type}-${it.value}`}>
              <X className="w-3 h-3 text-gray-500 hover:text-red-400" />
            </button>
          </span>
        ))}
      </div>
    )}
  </div>
);
